import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import './Home.css';

const Home = () => {
  const artBlocks = [
    {
      id: 1,
      title: 'Original Works',
      description: 'Explore unique paintings that capture emotion and authenticity through vibrant color and expressive form.',
      image: '/LowCountry1.png',
      link: '/original-work',
      buttonText: 'View Originals',
      collection: null
    },
    {
      id: 2,
      title: 'Fine Art Prints',
      description: 'Museum-quality prints that bring the beauty of original works into your space.',
      image: '/bw1.jpg',
      link: '/prints',
      buttonText: 'Shop Prints',
      collection: null
    },
    {
      id: 3,
      title: 'Black & White Collection',
      description: 'A study in contrast and form, exploring the depths of monochromatic expression.',
      image: '/bw2.jpg',
      link: '/collection/black-white',
      buttonText: 'Explore Collection',
      collection: 'black-white',
      collectionName: 'Black & White Collection'
    },
    {
      id: 4,
      title: 'Pink Collection',
      description: 'Vibrant pink artworks that capture emotion and energy.',
      image: '/pink1.jpg',
      link: '/collection/pink',
      buttonText: 'Explore Collection',
      collection: 'pink',
      collectionName: 'Pink Collection'
    },
    {
      id: 5,
      title: 'Oil Collection',
      description: 'Rich oil paintings with deep textures and timeless beauty.',
      image: '/Oil1.jpg',
      link: '/collection/oil',
      buttonText: 'Explore Collection',
      collection: 'oil',
      collectionName: 'Oil Collection'
    },
    {
      id: 6,
      title: 'Mini Collection',
      description: 'Small-scale artworks perfect for intimate spaces.',
      image: '/mini100.png',
      link: '/collection/mini',
      buttonText: 'Explore Collection',
      collection: 'mini',
      collectionName: 'Mini Collection'
    },
    {
      id: 7,
      title: 'Low Country Summer Collection',
      description: 'Works inspired by the natural rhythms of Charleston\'s coastal life.',
      image: '/LowCountry1.png',
      link: '/collection/lowcountry',
      buttonText: 'Explore Collection',
      collection: 'lowcountry',
      collectionName: 'Low Country Summer Collection'
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3
      }
    }
  };

  const blockVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: 'easeOut'
      }
    }
  };

  return (
    <div className="home">
      <motion.section
        className="hero-section"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <div className="hero-content">
          <motion.p
            className="hero-subtitle"
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            Original Works & Fine Art Prints by Lida Caudle
          </motion.p>
          <motion.p
            className="hero-description"
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            Charleston-based artist creating authentic, vibrant works inspired by coastal life
          </motion.p>
          <motion.div
            className="hero-buttons"
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.8 }}
          >
            <Link to="/original-work" className="cta-button primary">
              View Original Works
            </Link>
            <Link to="/about" className="cta-button secondary">
              About the Artist
            </Link>
          </motion.div>
        </div>
      </motion.section>

      <motion.section
        className="art-blocks-section"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: '-100px' }}
      >
        {artBlocks.map((block, index) => (
          <motion.div
            key={block.id}
            className={`art-block ${index % 2 === 0 ? 'left' : 'right'}`}
            variants={blockVariants}
          >
            <div className="art-block-image">
              <img src={block.image} alt={block.title} />
              <div className="art-block-overlay"></div>
              {block.collection && (
                <div className="collection-hover-overlay">
                  <a 
                    href={block.link} 
                    target="_blank"
                    rel="noopener noreferrer"
                    className="explore-collection-button"
                  >
                    Explore {block.collectionName}
                  </a>
                </div>
              )}
            </div>
            <div className="art-block-content">
              <h2 className="art-block-title">{block.title}</h2>
              <p className="art-block-description">{block.description}</p>
              <Link to={block.link} className="art-block-button">
                {block.buttonText}
              </Link>
            </div>
          </motion.div>
        ))}
      </motion.section>

      <motion.section
        className="cta-section"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      >
        <div className="cta-content">
          <h2 className="cta-title">Stay Connected</h2>
          <p className="cta-text">
            Be the first to know about new works, upcoming events, and exclusive opportunities.
          </p>
          <Link to="/contact" className="cta-button primary">
            Get in Touch
          </Link>
        </div>
      </motion.section>
    </div>
  );
};

export default Home;


